import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'theme-ui';

type footerProps = {
  showCalendar: boolean;
  lessonCount: number;
  lessonsDatesLeftToChoose: number;
  showSelectedDates: boolean;
  teacherSubjects: any;
};
function calendarFooter({
  showCalendar,
  lessonCount,
  lessonsDatesLeftToChoose,
  showSelectedDates,
  teacherSubjects,
}: footerProps) {
  const { t } = useTranslation();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {!showCalendar && lessonCount ? (
        <Box
          sx={{
            margin: '20px auto 0 auto',
            minHeight: '100px',
          }}
        >
          <ul>
            {teacherSubjects?.length > 1 && <li>{t('chooseSubject')}</li>}
            <li>{t('chooseGrade')}</li>
            <li>{t('writeLessonTopic')}</li>
          </ul>
        </Box>
      ) : (
        <Box
          sx={{
            textAlign: 'center',
            opacity: lessonCount >= 1 && showCalendar ? 1 : 0,
            margin: '20px 20px 0 20px',
            minHeight: '100px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: showSelectedDates ? 'end' : 'start',
          }}
        >
          <Flex sx={{ justifyContent: 'center' }}>
            {Array.from({ length: lessonCount }, (_, i) => (
              <Box
                key={i}
                sx={{
                  height: '9px',
                  borderRadius: '11px',
                  backgroundColor:
                    lessonsDatesLeftToChoose > lessonCount - 1 - i
                      ? 'primaryPale'
                      : 'primary',
                  margin: '3px',
                  flex: '1',
                }}
              />
            ))}
          </Flex>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: '10px',
              marginTop: '16px',
            }}
          >
            <Box sx={{ color: '#ACACAC' }}>{t('leftToChoose')}: </Box>
            <Box sx={{ fontWeight: 'bold' }}>{lessonsDatesLeftToChoose}</Box>
          </Box>
        </Box>
      )}
    </div>
  );
}

export default calendarFooter;
